import * as React from "react";

function SvgViewSingle(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}><path d="M38 12H12v26h26V12z" /></svg>;
}

export default SvgViewSingle;